import { render } from "./MainContainer.vue?vue&type=template&id=4a82e2a2&ts=true"
import script from "./MainContainer.vue?vue&type=script&lang=ts"
export * from "./MainContainer.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__